"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAddedProductsByVehicleId = exports.getAozStateRaw = void 0;
const getAozStateRaw = (state) => state.aoz || {};
exports.getAozStateRaw = getAozStateRaw;
const getAddedProductsByVehicleId = (state, vehicleId) => (0, exports.getAozStateRaw)(state)[vehicleId] || [];
exports.getAddedProductsByVehicleId = getAddedProductsByVehicleId;
//# sourceMappingURL=aozSelectors.js.map